import React from "react";
import "./implementation.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
export default function Implementation() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const [pointRef, isPointsVisible] = useIntersectionObserver({
    threshold: 0.1,
  });

  return (
    <section
      className={`implementation-section ${
        isVisible ? "section-animation" : ""
      }`}
      ref={ref}
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Implementation</span>
          </div>
          <div className="heading-description">
            <h2>A Data-Driven Approach to AI Reliability</h2>
          </div>
        </div>
        <div className="section-content-wrapper">
          <div className="two-points-wrapper">
            <h3>Agent Trust evaluates AI across two key dimensions</h3>
            <div className="two-points">
              <div>
                <h4>Data Integrity</h4>
                <p>Ensuring diverse, secure, and high-quality data </p>
              </div>
              <div>
                <h4>Model Performance</h4>
                <p>Measuring accuracy, fairness, and explainability </p>
              </div>
            </div>
          </div>

          <div className="trust-score-calculation-points" ref={pointRef}>
            <h3>AI Trust Score Calculation </h3>
            <div className="trust-score-calc-points-wrapper">
              <div className="trust-score-calc-point">
                <div
                  className={`pointer-icon ${isPointsVisible ? "point-1" : ""}`}
                >
                  <span>1</span>
                </div>
                <h4>Assess Data Reliability </h4>
                <p>
                  Diversity, Timeliness, Security, Discoverability,
                  Consumability
                </p>
              </div>
              <div className="trust-score-calc-point">
                <div
                  className={`pointer-icon ${isPointsVisible ? "point-2" : ""}`}
                >
                  <span>2</span>
                </div>
                <h4>Evaluate Model Integrity</h4>
                <p>Accuracy, Fairness, Explainability </p>
              </div>
              <div className="trust-score-calc-point">
                <div
                  className={`pointer-icon ${isPointsVisible ? "point-3" : ""}`}
                >
                  <span>3</span>
                </div>
                <h4>Compute Trust Score</h4>
                <p>Weighted scores determine AI trustworthiness </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
